import { handleError } from './handleError'

interface ParseJSONSafeOptions {
  /**
   * The fallback return value of the function if it cannot parse the JSON.
   */
  fallbackValue: unknown
}

/**
 * Attempts to parse a string into a JSON object, and returns a fallback value if the parsing fails.
 *
 * @param text - A string that needs to be parsed into a JavaScript object.
 */
export const parseJSONSafe = (
  text: string,
  { fallbackValue }: ParseJSONSafeOptions = { fallbackValue: {} },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
  try {
    const object = JSON.parse(text)

    return object
  } catch (error) {
    handleError(error, { message: 'The passed JSON cannot be safely parsed.' })

    return fallbackValue
  }
}
